import angular from 'angular';
import gettext from 'angular-gettext';
import MediaResource from '../MediaResource';
import config from '../../ConfigModule/ConfigModule';
import fileSize from '../../FileSizeFilter/FileSizeFilter';
import toastr from 'angular-toastr';

export default angular.module('cms.media.browser.tile', [config, MediaResource, fileSize, gettext, toastr])
    .component('mediaTile', {
        template: require('./media-tile.html'),
        bindings: {
            media: '<',
            softDelete: '<',
            onRemoved: '&',
            selectable: '<',
            onSelectionChange: '&',
            isSelected: '=',
            tileClass: '@',
            disabled: '<'
        },
        transclude: true,
        controller: function (CONFIG, MediaResource, $scope, toastr, gettextCatalog) {
            /** @ngInject */

            this.$onInit = () => {
                this.previewImage = this.media.key ? (CONFIG.API_PUBLIC + '/image/250x180/' + this.media.key) : null;
            };

            this.$onChanges = () => {
                this.previewImage = this.media.key ? (CONFIG.API_PUBLIC + '/image/250x180/' + this.media.key) : null;
            };

            this.toggleSelected = () => {
                if(!this.selectable)
                    return;

                this.isSelected = !this.isSelected;

                this.onSelectionChange({selected: this.isSelected});
            };

            this.onRemoveMedia = () => {

                if(this.softDelete) {
                    this.onRemoved(this.media);

                    $scope.$emit('content-changed');
                    return;
                }

                this.isRemoving = true;
                MediaResource.delete({id: this.media.id}, () => {
                    if (this.onRemoved) {
                        this.onRemoved(this.media);


                    }

                    $scope.$emit('content-changed');

                }, (error) => {
                    let errorMessage = error.data.id[0];
                    toastr.error(gettextCatalog.getString(errorMessage), gettextCatalog.getString("Cannot remove file."));
                    this.isRemoving = false;
                })
            }

        }
    })
    .name;



// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/MediaTile/MediaTile.js